export default __webpack_public_path__ + "46429d1fe330693d47ce3db5bde01e3e.png";